import React from 'react';
import myGlobals from '../Utils/globals';
import myUtilities from '../Utils/utils';
import NotificationSystem from 'react-notification-system';

class MyNotificationSystem extends React.Component {
    constructor(props){
      super(props);
      this.notificationSystem = React.createRef();
    }
    addNotification = (event,errorType,info) => {
    	let genericBlockedChars = '! " % * = + : ; < > ? \[ \\ \] ^ ` { | } ~ „ ˆ “ ” ';
    	if("ASCII_ONLY" == errorType){
    		genericBlockedChars = myGlobals.injectProp.formatMessage({id: "generic.pte.blacklisted.certianCharactersText", defaultMessage: "Certain characters like "}) 
    								+ info;
    	}
    	if(event != null && event != undefined){
    		event.preventDefault();
    	}
    	const notification = this.notificationSystem.current;
    	notification.clearNotifications();
    	notification.addNotification({
    		message: genericBlockedChars + myGlobals.injectProp.formatMessage({id: "generic.pte.blacklisted.characters", defaultMessage: "are not allowed"}),
    		level: 'warning',
    		position: "tc"
    	});
    }
    render(){
      return(
        <NotificationSystem ref={this.notificationSystem} />
      );
    }
    componentDidMount(){
      myUtilities.addNotification = this.addNotification;
    }
  }

  export default MyNotificationSystem;